export const keycloakBaseUrl =
	import.meta.env.VITE_KEYCLOAK_BASE_URL || 'http://localhost:8080';

export const keycloakRealm = import.meta.env.VITE_KEYCLOAK_REALM || 'cityzen';

export const keycloakClientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'cityzen-fe';

// Public SDK application identifier. It is safe to embed in the browser build; Chat Core combines
// it with the authenticated Keycloak user, tenant/app scope, and the exact allowed web origin.
export const chatKitPublishableKey = import.meta.env.VITE_CHAT_KIT_PUBLISHABLE_KEY || '';

// Buton „jurnal erori" în header — DOAR când e activat prin env (mediu de dev). Deschide
// ErrorDetailsDialog cu jurnalul pipeline-ului global de erori. În prod nu se setează variabila.
export const showErrorLog = import.meta.env.VITE_SHOW_ERROR_LOG === 'true';
